import { cloudStorage } from '@tma.js/sdk';
import dayjs from 'dayjs';
import { isMockedEnvironment } from './telegram';

export interface TimerState {
    questId: string;
    startTime: string | null;
    isRunning: boolean;
    pausedTime: number;
}

const TIMER_STORAGE_KEY = 'timer_state';

export const saveTimerState = async (state: TimerState): Promise<void> => {
    if (!isMockedEnvironment() && cloudStorage.isSupported()) {
        try {
            await cloudStorage.setItem(TIMER_STORAGE_KEY, JSON.stringify(state));
        } catch (error) {
            console.error('Failed to save timer state:', error);
        }
    }
};

export const restoreTimerState = async (): Promise<TimerState | null> => {
    if (!isMockedEnvironment() && cloudStorage.isSupported()) {
        try {
            const savedState = await cloudStorage.getItem(TIMER_STORAGE_KEY);
            if (savedState) {
                return JSON.parse(savedState) as TimerState;
            }
        } catch (error) {
            console.error('Failed to restore timer state:', error);
        }
    }
    return null;
};

export const clearTimerState = async (): Promise<void> => {
    if (!isMockedEnvironment() && cloudStorage.isSupported()) {
        try {
            await cloudStorage.deleteItem(TIMER_STORAGE_KEY);
        } catch (error) {
            console.log('Failed to clear timer state:', error);
        }
    }
};

export const calculateCurrentElapsedTime = (state: TimerState): number => {
    if (state.isRunning && state.startTime) {
        const savedStartTime = dayjs(state.startTime);
        const now = dayjs();
        return state.pausedTime + now.diff(savedStartTime);
    }
    return 0;
};
